import {Stack, Typography} from "@mui/joy"
import {useTranslation} from "react-i18next"
import {Language, LANGUAGE_STORAGE_KEY, SUPPORTED_LANGUAGES} from "../localization"

const LABELS: { [language in Language]: string } = {
    fr: "FR",
    en: "EN"
}

/**
 * Switches the app between its two languages.
 *
 * The choice is kept in the browser rather than on the account: it is made before signing in as
 * often as after, and it has to hold either way.
 */
const LanguageSwitch = () => {
    const {i18n} = useTranslation()
    const current = (SUPPORTED_LANGUAGES as readonly string[]).includes(i18n.language)
        ? i18n.language as Language
        : "fr"

    const choose = (language: Language) => {
        i18n.changeLanguage(language)

        try {
            localStorage.setItem(LANGUAGE_STORAGE_KEY, language)
        } catch (e) {
            // The language still applies for this visit
        }
    }

    return <Stack direction={"row"} gap={0.5} padding={0.5}
                  sx={{
                      borderRadius: "10px",
                      backgroundColor: "rgba(255,255,255,0.05)",
                      border: "1px solid rgba(255,255,255,0.08)"
                  }}>
        {SUPPORTED_LANGUAGES.map(language =>
            <Stack key={language} flex={1} alignItems={"center"} paddingY={0.5}
                   onClick={() => choose(language)}
                   sx={{
                       cursor: "pointer",
                       borderRadius: "8px",
                       backgroundColor: current === language ? "primary.100" : "transparent",
                       "&:hover": {backgroundColor: current === language ? undefined : "rgba(255,255,255,0.06)"}
                   }}>
                <Typography level={"body-xs"} fontWeight={600}
                            textColor={current === language ? "primary.800" : "text.tertiary"}>
                    {LABELS[language]}
                </Typography>
            </Stack>)}
    </Stack>
}

export default LanguageSwitch
